/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { getOrderLocationsAPI, LocationsType } from 'features/Location/services/location'
import {
  getCloudKitchenScheduleProductHubAPI,
  postCloudKitchenScheduleProductHubAPI,
} from 'features/Product/services/cloudKitchen'
import {
  getProductInventoriesAPI,
  GetProductInventoriesResponseType,
  putInventoryLocationAPI,
  PutInventoryLocationPayloadType,
  putInventoryLocationStatusAPI,
} from 'features/Product/services/inventory'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'

export const SLICE_NAME = 'hubSlice'
export const mappingHubLocations = [
  'HUB',
  'VENDING MACHINE',
  'MEGAHUB',
  'MEGAHUB 2.0',
  'DIGITAL GOODS',
  'ASTRO OFFLINE',
]

export const fetchGetHubLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetHubLocations`,
  async (_, { getState, rejectWithValue }) => {
    try {
      let locations: LocationsType[] = []
      const { auth } = getState() as StoreStateType

      if (auth.userData.isSuperAdmin) {
        const response = await getOrderLocationsAPI()
        locations = response.data.data
      } else {
        locations = auth.userData.user_locations.filter((loc) =>
          mappingHubLocations.includes(loc.location_type.toUpperCase()),
        )
      }

      return locations
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetProductHub = createAsyncThunk(
  `${SLICE_NAME}/fetchGetProductHub`,
  async (params: Parameters<typeof getProductInventoriesAPI>[0], { getState, rejectWithValue }) => {
    try {
      const {
        auth,
        hub: { query },
      } = getState() as StoreStateType

      const locationIds = params?.['filter.location_ids']?.length
        ? params['filter.location_ids']
        : auth.userData.user_locations
            .filter((loc) => mappingHubLocations.includes(loc.location_type.toUpperCase()))
            .map((loc) => loc.location_id)

      const response = await getProductInventoriesAPI({
        ...query,
        ...params,
        'filter.location_types': mappingHubLocations,
        'filter.location_ids': locationIds,
      })

      const result: GetProductInventoriesResponseType = {
        data: response.data.data,
        pagination: response.data.pagination,
      }

      return result
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchPutInventoryLocation = createAsyncThunk(
  `${SLICE_NAME}/fetchPutInventoryLocation`,
  async (
    data: {
      locationId: number
      productId: number
      payload: PutInventoryLocationPayloadType
    },
    { rejectWithValue, dispatch, getState },
  ) => {
    try {
      const {
        hub: { query },
      } = getState() as StoreStateType

      const response = await putInventoryLocationAPI(data.locationId, data.productId, data.payload)
      toastSuccess('Data berhasil diupdate')

      dispatch(
        fetchGetProductHub({
          ...query,
        }),
      )

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchPutInventoryLocationStatus = createAsyncThunk(
  `${SLICE_NAME}/fetchPutInventoryLocationStatus`,
  async (
    data: {
      locationId: number
      productId: number
      isActive: boolean
    },
    { rejectWithValue, getState, dispatch },
  ) => {
    try {
      const {
        hub: { query },
      } = getState() as StoreStateType

      const response = await putInventoryLocationStatusAPI(
        data.locationId,
        data.productId,
        data.isActive,
      )

      toastSuccess('Data berhasil diupdate')
      dispatch(
        fetchGetProductHub({
          ...query,
        }),
      )

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetCloudKitchenProductHub = createAsyncThunk(
  `${SLICE_NAME}/fetchGetCloudKitchenProductHub`,
  async (
    data: {
      productId: number
      locationId: number
    },
    { rejectWithValue },
  ) => {
    try {
      const { productId, locationId } = data

      const response = await getCloudKitchenScheduleProductHubAPI(productId, locationId)
      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchPostCloudKitchenSchedule = createAsyncThunk(
  `${SLICE_NAME}/fetchPostCloudKitchenSchedule`,
  async (
    payload: Parameters<typeof postCloudKitchenScheduleProductHubAPI>[0],
    { rejectWithValue },
  ) => {
    try {
      const response = await postCloudKitchenScheduleProductHubAPI(payload)

      toastSuccess('Jadwal berhasil disimpan')

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
